 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","4":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyCollections","30":"MyStudents","31":"Onboarding","32":"PracticeSkill","33":"PredefinedCollectionsDetail","34":"Pricing","35":"ProgressTracker","36":"RegistrationModal","37":"RelatedGuidedLesson","38":"Reviews","39":"SeasonalDaysDropdown","40":"Sellpage","41":"SubPlansList","42":"SwitchAccountModal","43":"TakeAssessmentModal","44":"vendors~Checkout","45":"vendors~Gift","46":"vendors~MemberHomepage","47":"vendors~MyStudents","48":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"9211685e7b71ed24d20a","1":"b9bdfcc785097d168358","2":"1b011e7290ccaa2c8f4e","3":"28a476abf3aac87c9b4d","4":"a7b8b5f847c423c6a032","5":"60ed61f94c0c05934561","6":"7ca948676a4657ef498a","7":"6b311dd7ea62353e3adb","8":"d229f8861eea0d4681a8","9":"30761b989041aec353ac","10":"b6a3aaf2ad457d65532e","11":"46181170701a0be1b318","12":"20f0a5b1fe31b715abf8","13":"c3d7a57b991163853652","14":"0f772b0329fc66d87b9d","15":"3fe0382b37e239eb9b85","16":"aa9eb608d51cfd82796c","17":"00cdae3a1061b1d53427","18":"619aab4346b7f688b859","19":"b0ae69874f5cb8b79fd5","20":"4a6c95ce64933a2a06cd","21":"216c8023c935784fa14f","22":"57778a068787d7bd614b","23":"ae09ef84ef92ebbab1b7","24":"47a1c5e39b11efda1416","25":"fa948d75f74d6fa5cb67","26":"ff925e45cb315c99590b","27":"7feb666a10425fa2a874","28":"860540d7a77ff95534bb","29":"9334b938e85f982d3bc2","30":"95c272b85bf4e41b8c99","31":"9fbe8dc548557acc51bf","32":"a67987a8b7e7ad7ed956","33":"96a90a9d8bee85abb03d","34":"32e37a8ede53e26f7f5d","35":"3b0251182b63944c46a7","36":"b8ee7c27822403dd8943","37":"8b818c1b1ab1e8ee049b","38":"c3d6ef04743d08d95760","39":"aeffe9b3ff605c10c0a1","40":"6499d7e4b4ea57cc4904","41":"243d8ab079cd4d6a888b","42":"30f8dffb0db6bd081a89","43":"cee007c15afc90131d85","44":"1482c31fe9a666b67d6c","45":"79de84e36b19e5406036","46":"47b81ab6071dba3cb5dc","47":"510b7bb26a918799ff76","48":"f47939a1be18cd1d004e","51":"3046be848477838490d9","52":"9ae7d9b17b3fce2b2d14"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1,"8":1,"9":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"28":1,"29":1,"30":1,"31":1,"32":1,"34":1,"35":1,"38":1,"39":1,"40":1,"43":1,"45":1,"51":1,"52":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","4":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyCollections","30":"MyStudents","31":"Onboarding","32":"PracticeSkill","33":"PredefinedCollectionsDetail","34":"Pricing","35":"ProgressTracker","36":"RegistrationModal","37":"RelatedGuidedLesson","38":"Reviews","39":"SeasonalDaysDropdown","40":"Sellpage","41":"SubPlansList","42":"SwitchAccountModal","43":"TakeAssessmentModal","44":"vendors~Checkout","45":"vendors~Gift","46":"vendors~MemberHomepage","47":"vendors~MyStudents","48":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"21c26712ad69a7171d89","7":"31d6cfe0d16ae931b73c","8":"711aa7e66c3e7d26a3cd","9":"afbef80752e07bbe2570","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"4ad35bb3dca41c2cae0b","13":"3568ec292a28530b61a4","14":"13a4e7436120b3088257","15":"681ffe45eaa49fb7d947","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"e4a0a2124f8b3b6446ac","19":"d56d9288e4c0c7368f48","20":"7c9ade4d0722da2d712c","21":"f504ac87107ebbb77c08","22":"0ccdbb0bed9d9a533985","23":"78f108ef2a1e16d4d1b4","24":"4c89bea8f7f35505c32a","25":"4cc2c2993d26eb9af700","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"8063bf354b418fa1823e","29":"ab19f0324e469dc86f86","30":"9bed5d853ab6af7882bd","31":"3e3946facd93a178be00","32":"5491656ee574e8b4a49d","33":"31d6cfe0d16ae931b73c","34":"146fb48c3a8f58aa70a0","35":"824c284a8359b1c24485","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"3eb70bdfce6885905434","39":"495c0b9853cb793a31ee","40":"ba010189d2bfdd022601","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"bf40f2159a5c06b0446f","44":"31d6cfe0d16ae931b73c","45":"ca68f8fa1dd9edae64fc","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","51":"c7c112df630d782cdeed","52":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([394,50]);
 	// run deferred modules when ready
 	return checkDeferredModules();
